module.exports = __webpack_public_path__ + "static/media/2.e804ce27.png";